import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { first } from 'rxjs/operators';
import { PartService } from './part.service';
import { firstValueFrom } from 'rxjs';
import { DataService } from './data.service';
import { RoService } from './ro.service';
import { MkgOSPart } from '../class/mkg-os-part';
import { MkgOS } from '../class/mkg-os';
import { LOG_REPORTER_KEYS, LogReporterService } from './log-reporter.service';
import { Money } from '../class/money';


export interface ItemNeedStock {
  amount: number,
  description: string,
  availableStock: number
}

@Injectable({
  providedIn: 'root'
})
export class RoPartService {
  private _isFromMatrix = false;


  constructor(
    private _http: HttpClient,
    private _dataService: DataService,
    private _partService: PartService,
    private _logReporter: LogReporterService
  ) { 
  }

  async addOrUpdate(ro: string, roPartFull: MkgOSPart): Promise<string> {
    const addTxtLogger = this._logReporter.textLogger(`RoPartService.add()`, LOG_REPORTER_KEYS.STOCK);
    const updateTxtLogger = this._logReporter.textLogger(`RoPartService.update()`, LOG_REPORTER_KEYS.STOCK);
    const errLogger = this._logReporter.errorLogger("RoPartService.addOrUpdate()", LOG_REPORTER_KEYS.STOCK);
    try {
      if(roPartFull.id){
        updateTxtLogger(`Atualizando peça ${roPartFull.part.id} ao orçamento/OS ${ro}, nova quantidade: ${roPartFull.amount()}`)
      } else {
      }
      const url = `${environment.mkgoURL}/api/v1/os/${ro}/parts`;
      const header = await firstValueFrom(this._dataService.httpOptions(this._isFromMatrix));
      const { id } = await firstValueFrom(this._http.post<{ id: string }>(url, roPartFull.toAPI(), header));
      if(!roPartFull.id){
        addTxtLogger(`Adicionando peça ${roPartFull.part.id} ao orçamento/OS ${ro}, OSpart: ${id}`)
      }
      return id;
    } catch (error) {
     console.error(error)
     errLogger(error); 
    }
  }

  async delete(ro: string, part: string): Promise<any> {
    const txtLogger = this._logReporter.textLogger("RoPartService.delete()", LOG_REPORTER_KEYS.STOCK);
    const errLogger = this._logReporter.errorLogger("RoPartService.delete()", LOG_REPORTER_KEYS.STOCK);
    try {
      txtLogger(`Removendo OSpart ${part} da OS ${ro}`)
      const url = `${environment.mkgoURL}/api/v1/os/${ro}/parts/${part}`;
      const header = await firstValueFrom(this._dataService.httpOptions(this._isFromMatrix));
      return firstValueFrom(this._http.delete(url, header));
    } catch (error) {
      console.error(error);
      errLogger(error);
    }
  }
  
  async verifyPartsStock(os: MkgOS): Promise<ItemNeedStock[]> {
    let partsWithoutStock: ItemNeedStock[] = [];
    for (const roPart of os.parts) {
      const partFull = roPart.part;

      if (partFull.availableStock < 0 && partFull.available !== 0) {
        partsWithoutStock.push({
          amount: roPart.amount(),
          description: partFull.description,
          availableStock: partFull.availableStock
        })
      }
    }
    return partsWithoutStock;
  }

  async checkPartCostsBeforeClosing(part: MkgOSPart, roId: string) {
    let averageCost = part.part.averageCost,
        cost = part.part.cost;
    
    if (averageCost === null || cost === undefined) {
      const partFull = await this._partService.get(part.part.id);

      averageCost = partFull.averageCost;
      cost = partFull.cost;
    }

    if ((Money(averageCost) !== Money(part.purchaseAverage)) || Money(cost) !== Money(part.purchaseValue)) {
      part.purchaseAverage = averageCost;
      part.purchaseValue = cost;

      this.addOrUpdate(roId, part)
    }
  }
}
